/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./compass.vue?vue&type=template&id=7553039a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports